<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Grupy</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="GROUP.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ GRUPĘ</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        editPerm="GROUP.UPDATE"
        deletePerm="GROUP.DELETE"
        :headers="headers"
        :items="list"
        :actions="true"
        :hideActions="false"
        :total-count="count"
        :search="search"
        @pagination="reloadList"
        @add="showAddModal"
        @edit="showEditModal"
        @delete="showDeleteDialog"
      ></material-table>

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy napewno chcesz usunąć grupę?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      ></material-dialog>
    </material-card>

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="update"></modal>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import MaterialDialog from '@/components/material/Dialog';
import Modal from './modals/add.modal';
import { listMixin } from '@/mixins/list';

// @vuese
// Wyświetlanie listy grup
// @group groups
export default {
  mixins: [
    listMixin('groups', {
      listError: 'Wystąpił błąd podczas pobierania grup.',
      getError: 'Wystąpił błąd podczas pobierania danych grup.',
      added: 'Dodano grupę.',
      addError: 'Nie udało się dodać grupy.',
      updated: 'Zaktualizowano dane grupy.',
      updateError: 'Nie udało się zaktualizować danych grupy.',
      deleted: 'Usunięto grupę.',
      deleteError: 'Nie udało się usunąć grupy.'
    })
  ],
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal
  },
  data() {
    return {
      search: '',
      headers: [{ value: 'name', text: 'Nazwa' }, { value: 'auto', text: 'Typ' }]
    };
  },
  computed: mapState({
    list: state =>
      state.groups.list.map(item => {
        return { name: item.name, auto: item.auto ? 'Automatyczna' : 'Manualna', id: item.id };
      })
  })
};
</script>
